import trelloStore from './trellostore';
import StoreKeys from './storekeys';

export interface ISetupData {
    isCompleted: boolean,
    integrationId: string,

    isShowEstimation: boolean,
    isShowEstimationOnCardFront: boolean,
    isShowEstimationOnCardBack: boolean,

    isEnableEditEstimation: boolean,
    storyPointScale: string,
    isStoryPointScaleValueCustomizable: boolean,
    isMarkBigStoryCards: boolean,
    bigStoryLimit: string,

    isShowStoryAttachemtns: boolean,

    isShowReleases: boolean,
    isShowReleasesOnCardFront: boolean,
    isShowReleasesOnCardBack: boolean,

    isShowCardContext: boolean,
    isShowCardContextGoalOnCardFront: boolean,
    isShowCardContextStepOnCardFront: boolean,
    isShowCardContextOnCardBack: boolean,

    isShowAnnotations: boolean,
    isShowAnnotationsOnCardFront: boolean,
    isShowAnnotationsOnCardBack: boolean,
    selectedAnnoatations: string[]
}

interface IConfig {
    get(): Promise<ISetupData>;
    set(setupData: ISetupData): Promise<any> ;
    getSetupIsCompleted(): Promise<boolean>;
    getAppKey(): string;
    getIconsBaseUrl(): string;
    getDefaultConfigObject(stobToken: string) : ISetupData;
    isUserAuthenticated(): Promise<boolean>;
    setPersonalAccessToken(pat: string): Promise<void>;
    getPersonalAccessToken(): Promise<string>;
    applyAnnotationFilter(annotations: string[]): Promise<string[]>;
}

class Config implements IConfig {

    private AppKey: string = '872b42270c821ad8a8668c6c9d97342c';
    //@ts-ignore
    private IconsBaseUrl: string = process.env.POWERUP_ROOT + '/public/icons/';

    private t: any;

    constructor(t?: any) {
        this.t = t;
    }

    public using(t: any) : IConfig {
        return new Config(t);
    }

    public getAppKey(): string {
        return this.AppKey;
    }

    public getIconsBaseUrl(): string {
        return this.IconsBaseUrl;
    }

    public get(): Promise<ISetupData> {
        var self = this;
        return new Promise(resolve => {
            trelloStore(self.t).getBoardShared<any>(StoreKeys.Board.SetupObject)
            .then(async (json) => {
                var setupObj : ISetupData = undefined;
                if (json) {
                    try {
                        setupObj = JSON.parse(json);
                    } catch (error) {
                    }
                }
                if (!setupObj) {
                    setupObj = this.getDefaultConfigObject(undefined);
                    await this.set(setupObj);
                }
                resolve(setupObj);
            });
        });
    }

    public getSetupIsCompleted(): Promise<boolean> {
        return new Promise(resolve => {
            this.get().then(res => {
                if (res && res.isCompleted) resolve(true)
                else resolve(false);
            })
        });
    }

    public set(setupData: ISetupData): Promise<any> {
        var self = this;
        return new Promise(resolve => {
            trelloStore(self.t)
            .setBoardShared(StoreKeys.Board.SetupObject,JSON.stringify(setupData))
            .then(() => {
                resolve(true);
            });
        });
    }

    public getDefaultConfigObject(stobToken: string) : ISetupData {
        return {
            isCompleted: false,
            integrationId: stobToken,

            isShowEstimation: true,
            isShowEstimationOnCardFront: true,
            isShowEstimationOnCardBack: true,

            isEnableEditEstimation: true,
            storyPointScale: '0,1,2,3,5,8,13,20,40,100',
            isStoryPointScaleValueCustomizable: true,
            isMarkBigStoryCards: true,
            bigStoryLimit: "13",

            isShowStoryAttachemtns: true,

            isShowReleases: true,
            isShowReleasesOnCardFront: true,
            isShowReleasesOnCardBack: true,

            isShowCardContext: true,
            isShowCardContextGoalOnCardFront: false,
            isShowCardContextStepOnCardFront: true,
            isShowCardContextOnCardBack: true,

            isShowAnnotations: true,
            isShowAnnotationsOnCardFront: true,
            isShowAnnotationsOnCardBack: true,
            selectedAnnoatations: []
        }
    }
        
    public setPersonalAccessToken = (pat: string) => {
        return trelloStore(this.t).setMemberPrivate(StoreKeys.Member.Token, pat);
    }

    public getPersonalAccessToken = async () => {
        var pat = await trelloStore(this.t).getMemberPrivate(StoreKeys.Member.Token);
        return pat;
    }

    public isUserAuthenticated = async () => {
        var pat = await this.getPersonalAccessToken();
        return pat != null;
    }

    public applyAnnotationFilter = async (annotations: string[]): Promise<string[]> => {
        var cfg = await this.get();
        var filteredAnnotations = annotations;
        if(cfg.selectedAnnoatations?.length > 0) {
            filteredAnnotations = filteredAnnotations.where(x => cfg.selectedAnnoatations.indexOf(x) > -1);
        }

        return filteredAnnotations;
    }
}

export var config = function(t: any): IConfig { return new Config().using(t); }
export default config;
